import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";

// MUI Imports
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

export const InvoiceTableFilterBar = ({ invoiceFilter, setInvoiceFilter }) => {
  const [currentSearchValue, setCurrentSearchValue] = useState(
    invoiceFilter.search || "",
  );
  const queryClient = useQueryClient();

  const handleSearchChange = (newValue) => {
    setCurrentSearchValue(newValue.target.value);
  };

  const handleSearchSumbit = (e) => {
    e.preventDefault();
    setInvoiceFilter((prevState) => ({
      ...prevState,
      search: currentSearchValue,
    }));
    invalidateInvoiceListQuery();
  };

  const handleSearchClear = () => {
    setCurrentSearchValue("");
    setInvoiceFilter((prevState) => ({
      ...prevState,
      search: "",
    }));
    invalidateInvoiceListQuery();
  };

  const invalidateInvoiceListQuery = () => {
    queryClient.invalidateQueries({
      queryKey: ["unpaidInvoiceListState"],
      exact: true,
    });
  };

  return (
    <Stack direction={{ xs: "column", md: "row" }} spacing={{ xs: 2, md: 1 }}>
      <Box component="form" onSubmit={handleSearchSumbit} sx={{ flexGrow: 1 }}>
        <TextField
          onChange={handleSearchChange}
          value={currentSearchValue}
          label="Search.."
          id="invoice-table-search"
          name="Search"
          variant="outlined"
          size="small"
          fullWidth
          slotProps={{
            input: {
              endAdornment: (
                <>
                  <InputAdornment
                    position="end"
                    sx={{
                      visibility: currentSearchValue ? "visible" : "hidden",
                    }}
                  >
                    <IconButton onClick={handleSearchClear} color="error">
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                  <InputAdornment position="end">
                    <IconButton type="submit">
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                </>
              ),
            },
          }}
        />
      </Box>
    </Stack>
  );
};
